"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ConfirmDialog;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ConfirmDialog(_ref) {
  var open = _ref.open,
      hide = _ref.hide,
      confirm = _ref.confirm,
      title = _ref.title,
      _ref$confirmText = _ref.confirmText,
      confirmText = _ref$confirmText === void 0 ? 'OK' : _ref$confirmText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      content = _ref.content;
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: open,
    onBackdropClick: hide,
    onEscapeKeyDown: hide
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    id: "alert-dialog-title"
  }, title), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, typeof content === 'string' ? /*#__PURE__*/_react.default.createElement(_DialogContentText.default, {
    id: "alert-dialog-description"
  }, content) : content), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: hide,
    color: "primary"
  }, cancelText), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: confirm,
    color: "primary",
    autoFocus: true
  }, confirmText)));
}

ConfirmDialog.propTypes = {
  open: _propTypes.default.bool.isRequired,
  hide: _propTypes.default.func.isRequired,
  confirm: _propTypes.default.func.isRequired,
  title: _propTypes.default.string,
  confirmText: _propTypes.default.string,
  cancelText: _propTypes.default.string,
  content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};